import { ApolloCache, DefaultContext, OperationVariables, useMutation } from "@apollo/client";
import { MutationBaseOptions } from "@apollo/client/core/watchQueryOptions";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { ManagedUser, ManagedUserUpdateInput } from "types/generated";

import { UPDATE_MANAGED_USER } from "./gql";

type ManagedUserUpdateResponse = {
  managedUserUpdate: ManagedUser;
};

const useUpdateUser = (
  refetchQueries?: MutationBaseOptions<
    ManagedUserUpdateResponse,
    OperationVariables,
    DefaultContext,
    ApolloCache<unknown>
  >["refetchQueries"]
) => {
  const { onError } = useTypedContext(FlashContext);

  const [updateManagedUser, { loading }] = useMutation<ManagedUserUpdateResponse>(
    UPDATE_MANAGED_USER,
    {
      onError,
      refetchQueries,
    }
  );

  const onUpdate = (input: ManagedUserUpdateInput) => {
    return updateManagedUser({
      variables: {
        input,
      },
    });
  };

  return { onUpdate, loading };
};

export default useUpdateUser;
